<template>
  <ModalDialog
    @input="$emit('close')"
  >
    <template slot="title">
      {{ title }}
    </template>
    <template slot="body">
      <v-card>
        <v-row
          no-gutters
          align="center"
          class="px-4 ma-2"
        >
          <v-col
            class="px-2 ma-2"
          >
            <Form
              ref="filterForm"
              :data="{ properties: formFields }"
              :buttons="[ $t('commons.search') ]"
              @click:submit="sendFilters(false)"
              :warningText=warningText
              isExtendedSearch
            >
            </Form>
            <p class="text-filter" v-if="isEmptyFilter">{{ $t('components.search.noFilter') }}</p>
          </v-col>
        </v-row>
      </v-card>

        <v-skeleton-loader
          v-if="loading && firstSearch"
          type="table: table-heading, table-tbody"
          class="mt-2"
        ></v-skeleton-loader>

        <v-data-table
          v-if="!firstSearch"
          style="cursor: pointer"
          :headers="filtersHead"
          :items="items"
          mobile
          hide-default-footer
          class="elevation-1 mt-2"
          :items-per-page="elementsPerTable"
          @click:row="$emit('send', $event)"
        >
        </v-data-table>

        <InfiniteScroll
          v-if="!loading && !firstSearch && hasMoreData"
          :size="10"
          :scroll=true
          :margin=marginScroll
          root="html"
          class="mt-4"
          @scrollList="scrollTickets(10)"
        ></InfiniteScroll>
        <div class="m-t-6 hidden">spinner</div>
    </template>
  </ModalDialog>
</template>

<script>
import FieldBuilderUtil from '@/components/form/field-builder-util';
import { InfiniteScroll } from '@/components';
import ModalDialog from '../../ModalDialog.vue';
import Form from '../Form.vue';

export default {
  components: {
    ModalDialog,
    Form,
    InfiniteScroll,
  },
  props: {
    filtersSearch: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => {},
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    title: String,
  },

  data() {
    return {
      loading: false,
      items: [],
      start: 0,
      size: 10,
      elementsPerTable: 10,
      isEmptyFilter: false,
      firstSearch: false,
      marginScroll: '0px',
      isLoadingMore: false,
      hasMoreData: true,
      resultTotal: 0,
    };
  },

  computed: {
    formFields() {
      return this.filtersSearch.map((filter, index) => {
        if (filter.text === 'Localización') {
          const user = this.$store.getters['session/user'];
          console.log('usuario =====', user.location.id);
          return FieldBuilderUtil
            .createField(filter.value).ofType('search')
            .withSequence(index)
            .withLabel(filter.text)
            .withConfig({
              initialValue: user.location.id,
              size: {
                sm: 4,
                md: 4,
                xl: 4,
                lg: 4,
              },
              inline: 'true',
            })
            .withParams({
              target: 'backend',
              entity: 'loc',
              match: 'name,znombre_sede',
              fields: 'id,name,state.id,state.name,site.id,site.name,site.node.id,site.node.name,site.alias,county',
              filters: '{"delete_flag":0}',
              lookandfeel: '#item.name #item.state.name::[ ($1)]',
              order: 'name',
              value: 'name',
              initialsearch: `{"isExtendedSearch": true, "target": "backend", "entity": "loc", "fields": "id,name,state.id,state.name,site.id,site.name,site.node.id,site.node.name,site.alias,county", "params": { "delete_flag": 0, "location_uuid": "${user.location.id}" }, "order": "name"}`,
            })
            .build();
        }
        return FieldBuilderUtil
          .createField(filter.value).ofType('text')
          .withSequence(index)
          .withLabel(filter.text)
          .withConfig({
            size: {
              sm: 4,
              md: 4,
              xl: 4,
              lg: 4,
            },
            inline: 'true',
          })
          .build();
      });
    },
    filtersHead() {
      return this.filtersSearch.filter((item) => (typeof item.display === 'undefined' || item.display === true));
    },
    warningText() {
      return this.resultTotal > 20 ? this.$t('validation.extendedSearchOverResults') : '';
    },
  },

  methods: {
    async sendFilters(isPagination) {
      this.loading = true;

      if (!isPagination) {
        this.resetValues();
      }

      const buildFilter = this.filters;
      const dataForm = this.$refs.filterForm.getFormData();
      Object.keys(dataForm)
        .forEach((key) => {
          if (dataForm && dataForm[key] !== '') {
            if (typeof dataForm[key] === 'object') {
              dataForm[key] = { $regex: `%${dataForm[key].value.toUpperCase()}%` };
            } else {
              dataForm[key] = { $regex: `%${dataForm[key].toUpperCase()}%` };
            }
          } else {
            delete dataForm[key];
          }
        });
      buildFilter.$or = [dataForm];

      this.isEmptyFilter = Object.keys(dataForm).length === 0;

      const result = await this.search({ filters: buildFilter });

      if (!result || !result.list || result.list.length < this.size) {
        this.hasMoreData = false;
      }

      const elementSearched = this.items.concat(result?.list || []);
      this.items = elementSearched;

      this.firstSearch = false;
      this.loading = false;
    },
    async search({ filters }) {
      const user = this.$store.getters['session/user'];
      const {
        target, entity, fields = 'id,name', order,
      } = this.params;

      const priorityQuery = {
        cityQuery: user.provinceUser.city,
        stateQuery: user.provinceUser.state,
        locationQuery: user?.location?.id,
      };

      let result = null;
      try {
        result = await this.client.search({
          target,
          entity,
          fields,
          filters,
          order,
          size: this.size,
          first: this.start,
          isPagination: true,
          priorityQuery,
        });

        this.resultTotal = result.total;
      } catch (ex) {
        this.loading = false;
        console.error('error during search request', ex);
      }
      return result;
    },
    async scrollTickets(increment) {
      if (this.isLoadingMore || !this.hasMoreData) {
        return;
      }

      this.isLoadingMore = true;

      this.start += increment;
      this.elementsPerTable += increment;
      this.marginScroll = '400px';

      await this.sendFilters(true);

      this.isLoadingMore = false;
    },
    async resetValues() {
      this.firstSearch = true;
      this.start = 0;
      this.elementsPerTable = 10;
      this.items = [];
      this.marginScroll = '100px';
      this.hasMoreData = true;
      this.isLoadingMore = false;
    },
  },
  async created() {
    this.client = this.$api.getClient('search');
  },
};
</script>
<style>
  /* each cell border in mobile */
.v-data-table>.v-data-table__wrapper .v-data-table__mobile-table-row {
  margin: 10px;
  border: 1px solid #ededed;
  display: block;
}
.hidden {
  color: #0000;
}
.text-filter {
  color: #b64351 !important;
  font-size: 12px;
}

#messages-panel {
  z-index: 203 !important;
}
</style>
